/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationDetail
 */
export interface NotificationDetail {
    /**
     * 
     * @type {number}
     * @memberof NotificationDetail
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationDetail
     */
    message: string;
    /**
     * 
     * @type {Date}
     * @memberof NotificationDetail
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof NotificationDetail
     */
    eventType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationDetail
     */
    severity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationDetail
     */
    readonly objectType: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDetail
     */
    readonly relatedObjects: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDetail
     */
    read?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NotificationDetail
     */
    readonly team: number;
    /**
     * Whether this notification has been enhanced by AI
     * @type {boolean}
     * @memberof NotificationDetail
     */
    aiEnhanced?: boolean;
    /**
     * Whether this notification has been sent via email
     * @type {boolean}
     * @memberof NotificationDetail
     */
    emailAlerted?: boolean;
    /**
     * Whether this notification has been sent to Slack
     * @type {boolean}
     * @memberof NotificationDetail
     */
    slackAlerted?: boolean;
    /**
     * Whether this notification has been displayed on the dashboard
     * @type {boolean}
     * @memberof NotificationDetail
     */
    dashboardAlerted?: boolean;
}

/**
 * Check if a given object implements the NotificationDetail interface.
 */
export function instanceOfNotificationDetail(value: object): value is NotificationDetail {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('objectType' in value) || value['objectType'] === undefined) return false;
    if (!('relatedObjects' in value) || value['relatedObjects'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function NotificationDetailFromJSON(json: any): NotificationDetail {
    return NotificationDetailFromJSONTyped(json, false);
}

export function NotificationDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'message': json['message'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'eventType': json['event_type'] == null ? undefined : json['event_type'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'objectType': json['object_type'],
        'relatedObjects': json['related_objects'],
        'read': json['read'] == null ? undefined : json['read'],
        'team': json['team'],
        'aiEnhanced': json['ai_enhanced'] == null ? undefined : json['ai_enhanced'],
        'emailAlerted': json['email_alerted'] == null ? undefined : json['email_alerted'],
        'slackAlerted': json['slack_alerted'] == null ? undefined : json['slack_alerted'],
        'dashboardAlerted': json['dashboard_alerted'] == null ? undefined : json['dashboard_alerted'],
    };
}

  export function NotificationDetailToJSON(json: any): NotificationDetail {
      return NotificationDetailToJSONTyped(json, false);
  }

  export function NotificationDetailToJSONTyped(value?: Omit<NotificationDetail, 'id'|'object_type'|'related_objects'|'team'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'event_type': value['eventType'],
        'severity': value['severity'],
        'read': value['read'],
        'ai_enhanced': value['aiEnhanced'],
        'email_alerted': value['emailAlerted'],
        'slack_alerted': value['slackAlerted'],
        'dashboard_alerted': value['dashboardAlerted'],
    };
}

